/**
 * Copyright (c) HashiCorp, Inc.
 */

import Component from '@glimmer/component';
import { concat } from '@ember/helper';
import {
  EXTERNAL_SOURCE_ICON_MAPPING,
  EXTERNAL_SOURCE_LABELS,
} from '../../../utils/service-list-item.ts';
import CutTextWithIcon from '../text-with-icon.gts';

import type { ExternalSource } from '../../../utils/external-source.ts';

export interface MetadataExternalSourceSignature {
  Args: {
    externalSource: ExternalSource;
  };
  Blocks: {
    default: [];
  };
  Element: HTMLDivElement;
}

export default class MetadataExternalSource extends Component<MetadataExternalSourceSignature> {
  get externalSourceIcon() {
    const { externalSource } = this.args;

    return externalSource !== undefined
      ? EXTERNAL_SOURCE_ICON_MAPPING[externalSource]
      : null;
  }

  get externalSourceText() {
    const { externalSource } = this.args;

    return externalSource !== undefined
      ? EXTERNAL_SOURCE_LABELS[externalSource]
      : null;
  }

  <template>
    {{#if @externalSource}}
      {{! TODO: add translation(CC-5314) }}
      <CutTextWithIcon
        @text={{concat "Registered via " this.externalSourceText}}
        {{! @glint-expect-error }}
        @icon={{this.externalSourceIcon}}
        @iconColor="var(--token-color-hashicorp-brand)"
        data-test-external-source={{@externalSource}}
      />
    {{/if}}
  </template>
}
